import React from 'react'
import image from '../../../assets/homepage_hp6.png'
const BannerBoxFour = () => {
    return (
        <>
            <div className="box1 bg-pink">
                <div className="bx-txt">
                    <h4>Headphone</h4>
                    <h3>
                        20% Off or more <span>Headphone Products</span>
                    </h3>
                    <a href="#" className="btn-buy">
                        BUY NOW
                    </a>
                </div>
                <div className="bx-img">
                    <img className="img-fluid" src={image} alt="" />
                </div>
            </div>

        </>
    )
}

export default BannerBoxFour